import React from 'react';
import {useState, useEffect} from "react"
import {Button, Col, Form, Modal, Row} from 'react-bootstrap';
import handwai_logo from '../Design/logo.png';
import AppWebReportSwitchPage from "../Components/AppWebReport/AppWebReportSwitchPage";


const AppWebReport = () => {
    const [postleitzahl, setPostleitzahl] = useState("")
    const [uid] = useState(window.location.pathname.split('/')[2])
    const [postleitzahlModal, setPostleitzahlModal] = useState(true)
    const [reportData, setReportData] = useState({})
    const [reportType, setReportType] = useState("")

    useEffect(() => {
        console.log(postleitzahl)
        console.log(postleitzahlModal, reportData, reportType)
    }, [])


    async function getWebReportData() {
        let apiBody = {
            data: {
                uid: uid,
                postleitzahl: postleitzahl.toString()
            }
        }

        let res = await fetch(process.env.REACT_APP_BACKEND_API_URI + "mobileappwebreport/getmobileappwebreport",
            {
                method: 'POST', headers: {
                    'Content-type': 'application/json',
                }, body: JSON.stringify(apiBody),
            })
            .then((response) => response.json())
            .catch((error) => {
                console.error('Error:', error);
            })
        return res
    }

    const logoStyle = {
        marginLeft: 20
    };
    localStorage.clear();

    return (
        <>
            <br/>
            <header><img
                alt='Handwai GmbH Company Logo'
                src={handwai_logo}
                width='300'
                height='75'
                style={logoStyle}
            /></header>
            <br/><br/>


            <AppWebReportSwitchPage
                postleitzahlModal={postleitzahlModal}
                reportType={reportType}
                reportData={reportData}
            />


            <Modal style={{padding: 20}} show={postleitzahlModal}>
                <Form className='handwai-dark' style={{padding: 10}}>
                    <Modal.Header style={{borderWidth: 0}} className='handwai-dark'>
                        <Modal.Title className='handwai-text-label-main'>Versenden</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className='handwai-dark'>

                        <Form.Group as={Row} className="mb-3" controlId='formTemplateHeadline'>
                            <Form.Label column sm={3} className='handwai-text-label-normal'>Postleitzahl
                                Bitte</Form.Label>
                            <Col sm={9}>
                                <Form.Control
                                    className='handwai-input'
                                    type='text'
                                    value={postleitzahl}
                                    onChange={async (e) => {
                                        setPostleitzahl(e.target.value)
                                    }}
                                />
                            </Col>
                        </Form.Group>

                    </Modal.Body>
                    <Modal.Footer style={{borderWidth: 0}} className='handwai-dark'>
                        <Button className='handwai-btn-login' variant='primary'
                                onClick={async () => {
                                    let data = await getWebReportData()
                                    setReportData(data.data.reportData)
                                    setPostleitzahlModal(false)
                                    setReportType(data.data.reportType)
                                }}
                        >
                            Erstellen
                        </Button>
                        <Button onClick={async () => {
                            setPostleitzahlModal(false)
                        }}
                                className='handwai-btn-logout'>
                            Abbrechen
                        </Button>

                    </Modal.Footer>
                </Form>
            </Modal>


        </>
    );

}

export default AppWebReport;
